var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
    },
    [
      _vm.errorMessage
        ? _c("div", { staticClass: "notification is-danger is-light" }, [
            _vm._v(" " + _vm._s(_vm.errorMessage) + " "),
          ])
        : _vm._e(),
      _c(
        "required-field",
        {
          attrs: {
            error: _vm.$v.profile.firstname.$error,
            required: _vm.$v.profile.firstname.required,
            label: "First name",
          },
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.$v.profile.firstname.$model,
                expression: "$v.profile.firstname.$model",
                modifiers: { trim: true },
              },
            ],
            staticClass: "input",
            class: { "is-danger": _vm.$v.profile.firstname.$error },
            attrs: { type: "text" },
            domProps: { value: _vm.$v.profile.firstname.$model },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.$v.profile.firstname,
                  "$model",
                  $event.target.value.trim()
                )
              },
              blur: function ($event) {
                return _vm.$forceUpdate()
              },
            },
          }),
        ]
      ),
      _c(
        "required-field",
        {
          attrs: {
            error: _vm.$v.profile.lastname.$error,
            required: _vm.$v.profile.lastname.required,
            label: "Last name",
          },
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.$v.profile.lastname.$model,
                expression: "$v.profile.lastname.$model",
                modifiers: { trim: true },
              },
            ],
            staticClass: "input",
            class: { "is-danger": _vm.$v.profile.lastname.$error },
            attrs: { type: "text" },
            domProps: { value: _vm.$v.profile.lastname.$model },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.$v.profile.lastname,
                  "$model",
                  $event.target.value.trim()
                )
              },
              blur: function ($event) {
                return _vm.$forceUpdate()
              },
            },
          }),
        ]
      ),
      _c(
        "required-field",
        {
          attrs: {
            error: _vm.$v.profile.email.$error,
            required: _vm.$v.profile.email.required,
            label: "Email",
          },
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.$v.profile.email.$model,
                expression: "$v.profile.email.$model",
                modifiers: { trim: true },
              },
            ],
            staticClass: "input",
            class: { "is-danger": _vm.$v.profile.email.$error },
            attrs: { type: "text" },
            domProps: { value: _vm.$v.profile.email.$model },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.$v.profile.email,
                  "$model",
                  $event.target.value.trim()
                )
              },
              blur: function ($event) {
                return _vm.$forceUpdate()
              },
            },
          }),
          !_vm.$v.profile.email.email
            ? _c("p", { staticClass: "help is-danger" }, [
                _vm._v(" We require a valid email address "),
              ])
            : _vm._e(),
        ]
      ),
      _c("required-field", { attrs: { label: "Job title (optional)" } }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.trim",
              value: _vm.$v.profile.jobtitle.$model,
              expression: "$v.profile.jobtitle.$model",
              modifiers: { trim: true },
            },
          ],
          staticClass: "input",
          attrs: { type: "text" },
          domProps: { value: _vm.$v.profile.jobtitle.$model },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(
                _vm.$v.profile.jobtitle,
                "$model",
                $event.target.value.trim()
              )
            },
            blur: function ($event) {
              return _vm.$forceUpdate()
            },
          },
        }),
      ]),
      _c(
        "required-field",
        {
          attrs: {
            error: _vm.$v.profile.image.$error,
            required: _vm.$v.profile.image.required,
            label: "Profile photo",
          },
        },
        [
          _c("image-upload", {
            attrs: { value: _vm.$v.profile.image.$model },
            on: { update: _vm.updateImage },
          }),
        ],
        1
      ),
      _c("hr"),
      _c("div", { staticClass: "buttons" }, [
        _c(
          "button",
          {
            staticClass: "button is-primary gtm-save",
            class: { "is-loading": _vm.fetching },
            attrs: { disabled: !_vm.isValid },
          },
          [_vm._v(" Save")]
        ),
        _c(
          "button",
          {
            staticClass: "button is-outlined gtm-cancel",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.cancel.apply(null, arguments)
              },
            },
          },
          [_vm._v(" Cancel ")]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }